const getTextBriefly = function(text) {
  if (!text || text.length < 60) return text;
  return text.substring(0, 60) + "...";
};

const getTextBrieflyWithLength = function(text, length) {
  if (!text || text.length < length) return text;
  return text.substring(0, length) + "...";
};

const formatCurrency = function(value) {
  if (value == null) return "";
  return value.toLocaleString("it-IT", { style: "currency", currency: "VND" });
};
const replaceAt = function({ startIndex, endIndex, originalText, replaceText }) {
  return originalText.substring(0, startIndex) + replaceText + originalText.substring(endIndex, originalText.length);
};
const findMatchRegexIndex = function({ text, textRegex }) {
  let lowerCaseText = text.toLowerCase();
  let lowerCaseTextRegex = textRegex.toLowerCase();
  //
  let regex = new RegExp(lowerCaseTextRegex, "g");
  let matchArr = [];
  let temp;
  while ((temp = regex.exec(lowerCaseText)) !== null) {
    matchArr.push({
      text: temp[0],
      index: regex.lastIndex
    });
  }
  return matchArr;
};

export default { getTextBriefly, formatCurrency, getTextBrieflyWithLength, replaceAt, findMatchRegexIndex };